import React from 'react';
import ChooseDeliveryPersonButtonProperties from "./ChooseDeliveryPersonButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import ChooseDeliveryPersonStore from "./ChooseDeliveryPersonStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./ChooseDeliveryPersonButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import Badge from '@mui/icons-material/Badge';
import DeliveryPersonSelectList from '../../Selects/DeliveryPersonSelectList/DeliveryPersonSelectList';
import DeliveryPerson from '../../../entities/DeliveryPerson';
import DeliveryPersonType from '../../../entities/DeliveryPersonType';

const ChooseDeliveryPersonButton: React.FC<ChooseDeliveryPersonButtonProperties> = ({
                                                                                deliveryPersonType = DeliveryPersonType.DELIVERY_PERSON,
                                                                                onClick = () => {
                                                                                },
                                                                                onSelect = () => {
                                                                                },
                                                                                showIcon = true,
                                                                                showText = true,
                                                                                disabled,
                                                                                className = '',
                                                                                rounded = false,
                                                                                size = ButtonSize.DEFAULT,
                                                                                type = ButtonType.DEFAULT,
                                                                                orderByGeosIdProximity = [],
                                                                                service,
                                                                            }) => {
    const classes = useStyles(showText);
    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new ChooseDeliveryPersonStore(commonContext);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }
    
    const onDeliveryPersonSelect = async (deliveryPerson?: DeliveryPerson) => {
        onSelect(deliveryPerson);
        onCloseModal();
    }

    const getText = () =>{
        switch(deliveryPersonType){
            case DeliveryPersonType.DELIVERY_PERSON:
                return i18n.translate("SELECT_DELIVERY_PERSON")
            case DeliveryPersonType.ORGANIZER:
                return i18n.translate("SELECT_ORGANIZER_PERSON")
        }
    }
    const getIcon = () =>{
        switch(deliveryPersonType){
            case DeliveryPersonType.DELIVERY_PERSON:
                return <DeliveryDiningIcon/>
            case DeliveryPersonType.ORGANIZER:
                return <Badge/>
        }
    }

    
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? getText() : ""}
                text={showText ? getText() : ""}
                type={type}
                icon={showIcon ? getIcon() : <></>}
            />  
        }
        return <Button
            text={showText ? getText() : ""}
            className={className}
            tooltip={!showText ? getText() : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? getIcon() : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={getText()} onClose={onCloseModal}
                       open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <DeliveryPersonSelectList
                            service={service}
                            selectedDeliveryPerson={store.selectedDeliveryPerson}
                            onDeliveryPersonSelect={onDeliveryPersonSelect}
                            orderByGeosIdProximity={orderByGeosIdProximity}
                        />
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default ChooseDeliveryPersonButton;
